export function loadRosterWorkbook(buffer,extension) {
  return new Promise((resolve,reject)=>{
    const worker=new Worker(new URL("./rosterFileWorker.js",import.meta.url));
    const stop=()=>{clearTimeout(timer);worker.terminate();};
    const timer=setTimeout(()=>{stop();reject(new Error("This spreadsheet took too long to read. Save a smaller roster as XLSX or CSV and try again."));},15000);
    worker.onmessage=event=>{if(event.data.ready){worker.postMessage({buffer,extension},[buffer]);return;}stop();if(event.data.error)reject(new Error(event.data.error));else resolve(event.data.sheets);};
    worker.onerror=()=>{stop();reject(new Error("Could not read the spreadsheet. Save it as XLSX or CSV and try again."));};
  });
}
